module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/product-images/fr-product-07-036356517334368ebb6c3b818f411150.jpg";